import "./GeneralSettings.css"
import React, { useEffect, useState, useRef } from "react";
import moment from 'moment-timezone';
import { getAllISOCodes } from 'iso-country-currency';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux';
import { useQuery } from 'react-query';
import { toast } from "react-toastify";
import { setAppSettings } from "../../../features/appSettings/appSettingsSlice.js";
import currencyCodes from "currency-codes";
import { ThreeDots } from "react-loader-spinner";
import Modal from "react-modal";
import crssrImage from "../../../images/singleinvoice/cross-red.svg";

const HrDocuments = (props) => {

    const [seoTitle, setAppSeoTitle] = useState(null);

    const [googleDriveClientId, setGoogleDriveClientId] = useState(null);
    const [googleDriveDeveloperKey, setGoogleDriveDeveloperKey] = useState(null);
    const [dropBoxClientId, setDropBoxClientId] = useState(null);

    const [showDocumentModal, setShowDocumentModal] = useState(false);

    const handleDocumentClose = () => {

        setShowDocumentModal(false);
    };

    const [apiToken, setApiToken] = useState(null);
    const dispatch = useDispatch();

    let token = null;
    const { user } = useSelector((state) => state.auth);
    const { appSettings } = useSelector((state) => state.appSettings);
    if (user) {
        if (user && user.token) {
            token = user.token;
        }
    }

    useEffect(() => {
        setApiToken(token);
    }, [token]);

    const [documentTitle, setDocumentTitle] = useState("");
    const [documentDescription, setDocumentDescription] = useState("");
    const [documentStatus, setDocumentStatus] = useState("");
    const [uploadedFile, setUploadedFile] = useState(null);

    const handleFileUpload = (e) => {
        setUploadedFile(e.target.files[0]);
    };

    const [isSubmitLoading, setIsSubmitLoading] = useState(false);

    const handleDocumentSubmit = async (e) => {

        e.preventDefault();
    }

    const uploadDocument = async (e, file, title, description, status) => {

        e.preventDefault();

        if (!uploadedFile) {
            toast.error("Please upload a document first.");
            return;
        }

        const formData = new FormData();
        formData.append('file', uploadedFile);
        formData.append('title', documentTitle);
        formData.append('description', documentDescription);
        formData.append('status', documentStatus);

        console.log([...formData]); // Now you can see all data in console

        return;

        try {

            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/upload-document`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        Authorization: `Bearer ${apiToken}`,
                    },
                }
            );
            return response.data;
        } catch (error) {
            console.error("Upload failed:", error);
            toast.error("Failed to upload document.");
            return null;
        }
    };

    return (
        <div>
            <div>
                <div>

                    <div className="security-outer noti-outer seo-settings">
                        <div class="security-inner noti-enable noti-head-noti">
                            <span class="custom-switch-description">Documents</span>
                        </div>
                        <div className="security-inner noti-enable">
                            <span className="custom-switch-description">
                                Client Id
                            </span>
                            <div className="seo-input" >
                                <input type="text" style={{ border: seoTitle === "" ? "1px solid red" : "", backgroundColor: seoTitle === "" ? "#fff6f6" : "" }} placeholder="xxxxxxxxxxxxxxxx" value={googleDriveClientId} onPaste={(e) => setGoogleDriveClientId(e.clipboardData.getData('text'))} onChange={(e) => setGoogleDriveClientId(e.target.value)} />
                            </div>
                        </div>

                        <div className="security-inner noti-enable">
                            <span className="custom-switch-description">
                                Developer Key
                            </span>
                            <div className="seo-input" >
                                <input type="text" style={{ border: seoTitle === "" ? "1px solid red" : "", backgroundColor: seoTitle === "" ? "#fff6f6" : "" }} placeholder="xxxxxxxxxxxxxxxx" value={googleDriveDeveloperKey} onPaste={(e) => setGoogleDriveDeveloperKey(e.clipboardData.getData('text'))} onChange={(e) => setGoogleDriveDeveloperKey(e.target.value)} />
                            </div>
                        </div>
                    </div>


                    {/* Modal */}

                    <Modal
                        className="select-users-alert"
                        isOpen={showDocumentModal}
                        onRequestClose={handleDocumentClose}
                        contentLabel="Set Threshold"
                        style={{
                            content: {
                                height: "auto",
                                width: "400px",
                                maxHeight: "90vh",
                                overflowY: "auto",
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                padding: "20px",
                                borderRadius: "10px",
                                boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
                            },
                            overlay: {
                                backgroundColor: "rgba(0, 0, 0, 0.4)",
                            },
                        }}
                    >
                        <div className="modal">
                            <div className="modal-close-invite outter-modal-main">
                                <a className="" onClick={handleDocumentClose}>
                                    <img src={crssrImage} alt="Edit Icon" />{" "}
                                </a>
                            </div>
                            <div className="modal-client-head">
                                <h2 className="">
                                    Add Documents
                                </h2>
                            </div>
                            <div className="form-field-client-outer">
                                <form onSubmit={uploadDocument}>
                                    <div className="form-field-client">
                                        <label htmlFor="documentTitle" className="form-label">
                                            Document Title
                                        </label>
                                        <input
                                            type="text"
                                            id="documentTitle"
                                            name="documentTitle"
                                            className="form-input"
                                            value={documentTitle}
                                            onChange={(e) => setDocumentTitle(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="form-field-client">
                                        <label htmlFor="documentDescription" className="form-label">
                                            Document Description
                                        </label>
                                        <textarea
                                            id="documentDescription"
                                            name="documentDescription"
                                            className="form-input"
                                            value={documentDescription}
                                            onChange={(e) => setDocumentDescription(e.target.value)}
                                            required
                                            rows={3}
                                        ></textarea>
                                    </div>

                                    <div className="form-field-client">
                                        <label htmlFor="documentStatus" className="form-label">
                                            Status
                                        </label>
                                        <select
                                            id="documentStatus"
                                            name="documentStatus"
                                            className="form-input"
                                            value={documentStatus}
                                            onChange={(e) => setDocumentStatus(e.target.value)}
                                            required
                                        >
                                            <option value="">Select Status</option>
                                            <option value="Active">Active</option>
                                            <option value="Inactive">Inactive</option>
                                        </select>
                                    </div>

                                    <div className="form-field-client">
                                        <label htmlFor="uploadedFile" className="form-label">
                                            Upload Document
                                        </label>
                                        <input
                                            type="file"
                                            id="uploadedFile"
                                            name="uploadedFile"
                                            className="form-input"
                                            accept=".pdf,.doc,.docx,.jpg,.png"
                                            onChange={handleFileUpload}
                                            required
                                        />
                                    </div>


                                    {isSubmitLoading ? (
                                        <div className="outter-load-table">
                                            <ThreeDots
                                                height="38"
                                                width="40"
                                                radius="9"
                                                color="#6479f9"
                                                ariaLabel="three-dots-loading"
                                                wrapperStyle={{}}
                                                wrapperClassName=""
                                                visible={true}
                                            />
                                        </div>
                                    ) : (
                                        <div className="form-field-client-btns">
                                            <button
                                                type="submit"
                                                className="save-changes"
                                                disabled={isSubmitLoading}
                                            >
                                                {global.config.locate(
                                                    appSettings && appSettings.language,
                                                    "Save_changes"
                                                )}
                                            </button>
                                        </div>
                                    )}
                                </form>
                            </div>
                        </div>
                    </Modal>
                    {/* end modal */}

                </div>
            </div>
        </div>
    );
};

export default HrDocuments;